import { NUMBER_FORMAT_CONSTANTS } from '../constants';
import { NumberFormatOptions } from '../enums';

export const NumberFormattingUtil = {
    getPrefix(format: string): string {
        switch (format) {
            case NumberFormatOptions.USDollar:
                return NUMBER_FORMAT_CONSTANTS.usDollarPrefix;
            default:
                return '';
        }
    },
    getSuffix(format: string, value: any): string {
        switch (format) {
            case NumberFormatOptions.Percent:
                return NUMBER_FORMAT_CONSTANTS.percentSuffix;
            case NumberFormatOptions.Duration:
                const dayNumericValue = parseFloat(value);

                if (isNaN(dayNumericValue)) {
                    return "";
                }

                return !isNaN(dayNumericValue) && Math.abs(dayNumericValue) === 1
                    ? NUMBER_FORMAT_CONSTANTS.durationSuffixSingular
                    : NUMBER_FORMAT_CONSTANTS.durationSuffixPlural;
            case NumberFormatOptions.Hours:
                const hoursNumericValue = parseFloat(value);

                if (isNaN(hoursNumericValue)) {
                    return "";
                }

                return !isNaN(hoursNumericValue) && Math.abs(hoursNumericValue) === 1
                    ? NUMBER_FORMAT_CONSTANTS.hoursSuffixSingular
                    : NUMBER_FORMAT_CONSTANTS.hoursSuffixPlural;
            default:
                return '';
        }
    },
    formatNumberDecimalPlaces(value: any, decimalPlaces: number, format?: string): string {
        const numericValue = parseFloat(value);
        if (isNaN(numericValue)) {
            return value.toString();
        }

        if (format === NumberFormatOptions.USDollar) {
            const resolvedDecimalPlaces = decimalPlaces != null && decimalPlaces >= 0
                ? decimalPlaces
                : 2;

            return numericValue.toLocaleString('en-US', {
                minimumFractionDigits: resolvedDecimalPlaces,
                maximumFractionDigits: resolvedDecimalPlaces
            });
        }

        if (decimalPlaces != null && decimalPlaces >= 0) {
            return numericValue.toFixed(decimalPlaces).toString();
        }
        return value.toString();
    },
    formatNumberToDuration(value: any): string {
        const numericValue = parseFloat(value);

        if (isNaN(numericValue)) {
            return value?.toString();
        }
        return Math.ceil(numericValue).toString();
    },
    isMeasureofTime(format: string): boolean {
        return (format === NumberFormatOptions.Duration || format === NumberFormatOptions.Hours);
    }
};
